import { CHATV1_IS_PROD } from '../chatv1/config'

/**
 * GAMES ARE ON — owner, 2026-10-19: 測過了, 推 prod. They were dev-only until then (西洋棋做完之後, 放到 dev 上面讓我測):
 * a production build hid them, because main is shared and another lane's prod build from it must not ship a game
 * nobody had tested there. Now every build shows them; `VITE_GAMES=off` is the switch that hides them again.
 */
export function gamesOn(): boolean {
  return (import.meta.env as Record<string, string | undefined>)['VITE_GAMES'] !== 'off'
}

/**
 * GOMOKU IS ON — owner, 2026-10-19: 五子棋可以推到 Production 了. Until then a production build left it out of the list
 * (main is shared, and another lane builds production from it). Now every build lists it; `VITE_GOMOKU=off` hides it.
 */
export function gomokuOn(): boolean {
  return (import.meta.env as Record<string, string | undefined>)['VITE_GOMOKU'] !== 'off'
}

/**
 * XIANGQI IS ON — owner, 2026-10-21: 跟 avg-game 的改動一起 push to prod. Until then a production build left it out of the
 * list (main is shared, and another lane builds production from it). Now every build lists it; `VITE_XIANGQI=off` hides it.
 */
export function xiangqiOn(): boolean {
  return (import.meta.env as Record<string, string | undefined>)['VITE_XIANGQI'] !== 'off'
}

/**
 * MAHJONG — owner, 2026-10-26: 開始做麻將. On dev for him to try; a build whose chat is production's leaves it out of
 * the list until he says it goes (main is shared, and another lane builds production from it). `VITE_MAHJONG=on`
 * shows it anywhere, `=off` hides it anywhere.
 */
export function mahjongOn(): boolean {
  const v = (import.meta.env as Record<string, string | undefined>)['VITE_MAHJONG']
  return v === 'on' || (v !== 'off' && !CHATV1_IS_PROD)
}
